import layout from 'layouts/default'
import toastr from 'toastr'
import formFields from './formFields'

export default {
  name: 'new-integration-system',
  components: {
    layout,
    formFields
  },
  data () {
    return {
      form: {
        name: '',
        type: 'parking',
        attributes: [],
      },
      processing: false,
      errors: {}
    }
  },
  methods: {
    submit () {
      this.errors = {}
      this.processing = true

      this.$store.dispatch('integrationSystems.create', this.form).then(() => {
        this.processing = false
        const error = this.$store.state.integrationSystems.errors
        if (error) {
          this.errors = _.cloneDeep(error.errors || {})
          toastr.error(error.message)
        } else {
          this.$router.replace({name: 'integrationSystems.all'})
        }
      })
    }
  }
}
